import { render, staticRenderFns } from "./SourceIcon.vue?vue&type=template&id=1518fe2c"
import script from "./SourceIcon.vue?vue&type=script&lang=js"
export * from "./SourceIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports